// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Table Compact - Clean, professional table design
 * Responsive with hover states and striped rows
 */

.table-wrapper {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  box-shadow: var(--shadow-sm);
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-lg);
  border-bottom: 1px solid var(--border);
  background-color: var(--bg-toolbar);
}

.table-header-title {
  font-size: var(--text-xl);
  font-weight: var(--fw-semibold);
  color: var(--text-primary);
  margin: 0;
}

.table-header-actions {
  display: flex;
  gap: var(--spacing-md);
  align-items: center;
}

.table-filters {
  display: flex;
  gap: var(--spacing-md);
  flex-wrap: wrap;
}

.table-search {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  background: var(--bg-input);
  border: 1px solid var(--slate-200);
  border-radius: var(--radius-sm);
  padding: var(--spacing-sm);
  flex: 1 1;
  min-width: 200px;
}

.table-search input {
  flex: 1 1;
  border: none;
  background: transparent;
  font-size: var(--text-sm);
  color: var(--text-primary);
  outline: none;
}

.table-search input::placeholder {
  color: var(--text-muted);
}

.table-scroll {
  overflow-x: auto;
}

.list-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--text-sm);
}

.list-table thead {
  background-color: var(--bg-toolbar);
  border-bottom: 2px solid var(--slate-200);
}

.list-table th {
  padding: var(--spacing-md) var(--spacing-lg);
  text-align: left;
  font-weight: var(--fw-semibold);
  color: var(--text-muted);
  font-size: var(--text-xs);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
  border: none;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.list-table th:hover {
  color: var(--text-primary);
}

.list-table th:last-child {
  cursor: default;
}

.list-table tbody tr {
  border-bottom: 1px solid var(--border);
  transition: background-color var(--transition-fast);
}

.list-table tbody tr:last-child {
  border-bottom: none;
}

.list-table tbody tr:nth-child(even) {
  background-color: var(--bg-toolbar);
}

.list-table tbody tr:nth-child(odd) {
  background-color: transparent;
}

.list-table tbody tr:hover {
  background-color: rgba(var(--accent-rgb),.07) !important;
}

.list-table td {
  padding: var(--spacing-md) var(--spacing-lg);
  color: var(--text-primary);
  vertical-align: middle;
  border: none;
}

.list-table td.text-secondary {
  color: var(--slate-600);
}

.list-table td.text-muted {
  color: var(--slate-400);
}

.list-table td.align-right {
  text-align: right;
}

.list-table td.align-center {
  text-align: center;
}

/* Actions column */
.list-table .col-actions {
  text-align: right;
  white-space: nowrap;
  width: 1%;
  padding-right: 12px;
}

.list-table .col-actions-inner {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: var(--radius-sm);
  font-size: var(--text-xs);
  font-weight: var(--fw-semibold);
  white-space: nowrap;
}

.status-badge.active {
  background-color: var(--green-50);
  color: var(--green-600);
}

.status-badge.inactive {
  background-color: var(--red-50);
  color: var(--red-600);
}

.status-badge.warning {
  background-color: var(--amber-50);
  color: var(--amber-600);
}

.status-badge.info {
  background-color: var(--blue-50);
  color: var(--blue-600);
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}

.status-badge.active .status-dot {
  background-color: var(--green-600);
}

.status-badge.inactive .status-dot {
  background-color: var(--red-600);
}

.status-badge.warning .status-dot {
  background-color: var(--amber-600);
}

.status-badge.info .status-dot {
  background-color: var(--blue-600);
}

/* Actions */
.table-actions {
  display: flex;
  gap: var(--spacing-xs);
  justify-content: flex-end;
}

.btn-icon,
.btn-action {
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px solid var(--slate-200);
  background: var(--bg-toolbar, rgba(255,255,255,.05));
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  color: var(--slate-500);
  flex-shrink: 0;
  text-decoration: none;
  vertical-align: middle;
}

.btn-icon:hover,
.btn-action:hover {
  border-color: var(--blue-600);
  color: var(--blue-600);
  background-color: var(--blue-50);
}

.btn-icon:focus,
.btn-action:focus {
  outline: 2px solid var(--blue-600);
  outline-offset: 1px;
}

.btn-icon.danger:hover,
.btn-action.btn-action--danger:hover {
  border-color: var(--red-600);
  color: var(--red-600);
  background-color: var(--red-50);
}

.btn-action.btn-action--warning:hover {
  border-color: var(--amber-600);
  color: var(--amber-600);
  background-color: var(--amber-50);
}

.btn-icon svg,
.btn-action svg {
  width: 15px;
  height: 15px;
  stroke-width: 1.8;
}

/* Empty state */
.table-empty {
  padding: var(--spacing-2xl) var(--spacing-lg);
  text-align: center;
  color: var(--slate-600);
}

.table-empty-icon {
  width: 48px;
  height: 48px;
  margin: 0 auto var(--spacing-lg);
  opacity: 0.5;
}

.table-empty-title {
  font-size: var(--text-lg);
  font-weight: var(--fw-semibold);
  margin-bottom: var(--spacing-sm);
  color: var(--slate-900);
}

.table-empty-description {
  font-size: var(--text-sm);
  color: var(--slate-600);
}

/* Pagination */
.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-lg);
  border-top: 1px solid var(--slate-200);
  background-color: var(--slate-50);
  font-size: var(--text-sm);
}

.pagination {
  display: flex;
  gap: var(--spacing-xs);
}

.pagination button {
  width: 32px;
  height: 32px;
  border: 1px solid var(--slate-200);
  background: var(--bg-toolbar, rgba(255,255,255,.05));
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
  font-size: var(--text-sm);
  font-weight: var(--fw-medium);
  color: var(--slate-600);
}

.pagination button:hover:not(:disabled) {
  border-color: var(--blue-600);
  color: var(--blue-600);
  background-color: var(--blue-50);
}

.pagination button.active {
  border-color: var(--blue-600);
  background-color: var(--blue-600);
  color: #ffffff;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 768px) {
  .list-table {
    font-size: var(--text-xs);
  }

  .list-table th,
  .list-table td {
    padding: var(--spacing-md) var(--spacing-md);
  }

  .btn-icon,
  .btn-action {
    width: 28px;
    height: 28px;
  }

  .btn-icon svg,
  .btn-action svg {
    width: 14px;
    height: 14px;
  }

  .table-header {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-md);
  }

  .table-filters {
    width: 100%;
  }

  .table-search {
    width: 100%;
  }

  .table-header-actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .table-footer {
    flex-direction: column;
    gap: var(--spacing-md);
    text-align: center;
  }
}

@media (max-width: 480px) {
  .table-scroll {
    border-radius: 0;
  }

  .list-table th,
  .list-table td {
    padding: var(--spacing-sm) var(--spacing-sm);
  }

  .table-actions {
    gap: 0;
  }

  .btn-icon,
  .btn-action {
    width: 24px;
    height: 24px;
    border-radius: 2px;
  }

  .btn-icon svg,
  .btn-action svg {
    width: 12px;
    height: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/table-compact.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;EAC1B,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,+BAA+B;EAC/B,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,4CAA4C;EAC5C,0BAA0B;EAC1B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,oDAAoD;EACpD,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;;EAEE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;EAC5B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,sCAAsC;EACtC,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,oDAAoD;EACpD,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,4CAA4C;EAC9C;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;IAEE,4CAA4C;EAC9C;;EAEA;IACE,MAAM;EACR;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/**\r\n * Table Compact - Clean, professional table design\r\n * Responsive with hover states and striped rows\r\n */\r\n\r\n.table-wrapper {\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  overflow-x: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.table-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: var(--spacing-lg);\r\n  border-bottom: 1px solid var(--border);\r\n  background-color: var(--bg-toolbar);\r\n}\r\n\r\n.table-header-title {\r\n  font-size: var(--text-xl);\r\n  font-weight: var(--fw-semibold);\r\n  color: var(--text-primary);\r\n  margin: 0;\r\n}\r\n\r\n.table-header-actions {\r\n  display: flex;\r\n  gap: var(--spacing-md);\r\n  align-items: center;\r\n}\r\n\r\n.table-filters {\r\n  display: flex;\r\n  gap: var(--spacing-md);\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.table-search {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-sm);\r\n  background: var(--bg-input);\r\n  border: 1px solid var(--slate-200);\r\n  border-radius: var(--radius-sm);\r\n  padding: var(--spacing-sm);\r\n  flex: 1;\r\n  min-width: 200px;\r\n}\r\n\r\n.table-search input {\r\n  flex: 1;\r\n  border: none;\r\n  background: transparent;\r\n  font-size: var(--text-sm);\r\n  color: var(--text-primary);\r\n  outline: none;\r\n}\r\n\r\n.table-search input::placeholder {\r\n  color: var(--text-muted);\r\n}\r\n\r\n.table-scroll {\r\n  overflow-x: auto;\r\n}\r\n\r\n.list-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: var(--text-sm);\r\n}\r\n\r\n.list-table thead {\r\n  background-color: var(--bg-toolbar);\r\n  border-bottom: 2px solid var(--slate-200);\r\n}\r\n\r\n.list-table th {\r\n  padding: var(--spacing-md) var(--spacing-lg);\r\n  text-align: left;\r\n  font-weight: var(--fw-semibold);\r\n  color: var(--text-muted);\r\n  font-size: var(--text-xs);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.3px;\r\n  white-space: nowrap;\r\n  border: none;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.list-table th:hover {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.list-table th:last-child {\r\n  cursor: default;\r\n}\r\n\r\n.list-table tbody tr {\r\n  border-bottom: 1px solid var(--border);\r\n  transition: background-color var(--transition-fast);\r\n}\r\n\r\n.list-table tbody tr:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.list-table tbody tr:nth-child(even) {\r\n  background-color: var(--bg-toolbar);\r\n}\r\n\r\n.list-table tbody tr:nth-child(odd) {\r\n  background-color: transparent;\r\n}\r\n\r\n.list-table tbody tr:hover {\r\n  background-color: rgba(var(--accent-rgb),.07) !important;\r\n}\r\n\r\n.list-table td {\r\n  padding: var(--spacing-md) var(--spacing-lg);\r\n  color: var(--text-primary);\r\n  vertical-align: middle;\r\n  border: none;\r\n}\r\n\r\n.list-table td.text-secondary {\r\n  color: var(--slate-600);\r\n}\r\n\r\n.list-table td.text-muted {\r\n  color: var(--slate-400);\r\n}\r\n\r\n.list-table td.align-right {\r\n  text-align: right;\r\n}\r\n\r\n.list-table td.align-center {\r\n  text-align: center;\r\n}\r\n\r\n/* Actions column */\r\n.list-table .col-actions {\r\n  text-align: right;\r\n  white-space: nowrap;\r\n  width: 1%;\r\n  padding-right: 12px;\r\n}\r\n\r\n.list-table .col-actions-inner {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 4px;\r\n}\r\n\r\n/* Status Badges */\r\n.status-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 4px 8px;\r\n  border-radius: var(--radius-sm);\r\n  font-size: var(--text-xs);\r\n  font-weight: var(--fw-semibold);\r\n  white-space: nowrap;\r\n}\r\n\r\n.status-badge.active {\r\n  background-color: var(--green-50);\r\n  color: var(--green-600);\r\n}\r\n\r\n.status-badge.inactive {\r\n  background-color: var(--red-50);\r\n  color: var(--red-600);\r\n}\r\n\r\n.status-badge.warning {\r\n  background-color: var(--amber-50);\r\n  color: var(--amber-600);\r\n}\r\n\r\n.status-badge.info {\r\n  background-color: var(--blue-50);\r\n  color: var(--blue-600);\r\n}\r\n\r\n.status-dot {\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n}\r\n\r\n.status-badge.active .status-dot {\r\n  background-color: var(--green-600);\r\n}\r\n\r\n.status-badge.inactive .status-dot {\r\n  background-color: var(--red-600);\r\n}\r\n\r\n.status-badge.warning .status-dot {\r\n  background-color: var(--amber-600);\r\n}\r\n\r\n.status-badge.info .status-dot {\r\n  background-color: var(--blue-600);\r\n}\r\n\r\n/* Actions */\r\n.table-actions {\r\n  display: flex;\r\n  gap: var(--spacing-xs);\r\n  justify-content: flex-end;\r\n}\r\n\r\n.btn-icon,\r\n.btn-action {\r\n  width: 30px;\r\n  height: 30px;\r\n  padding: 0;\r\n  border: 1px solid var(--slate-200);\r\n  background: var(--bg-toolbar, rgba(255,255,255,.05));\r\n  border-radius: var(--radius-sm);\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all var(--transition-fast);\r\n  color: var(--slate-500);\r\n  flex-shrink: 0;\r\n  text-decoration: none;\r\n  vertical-align: middle;\r\n}\r\n\r\n.btn-icon:hover,\r\n.btn-action:hover {\r\n  border-color: var(--blue-600);\r\n  color: var(--blue-600);\r\n  background-color: var(--blue-50);\r\n}\r\n\r\n.btn-icon:focus,\r\n.btn-action:focus {\r\n  outline: 2px solid var(--blue-600);\r\n  outline-offset: 1px;\r\n}\r\n\r\n.btn-icon.danger:hover,\r\n.btn-action.btn-action--danger:hover {\r\n  border-color: var(--red-600);\r\n  color: var(--red-600);\r\n  background-color: var(--red-50);\r\n}\r\n\r\n.btn-action.btn-action--warning:hover {\r\n  border-color: var(--amber-600);\r\n  color: var(--amber-600);\r\n  background-color: var(--amber-50);\r\n}\r\n\r\n.btn-icon svg,\r\n.btn-action svg {\r\n  width: 15px;\r\n  height: 15px;\r\n  stroke-width: 1.8;\r\n}\r\n\r\n/* Empty state */\r\n.table-empty {\r\n  padding: var(--spacing-2xl) var(--spacing-lg);\r\n  text-align: center;\r\n  color: var(--slate-600);\r\n}\r\n\r\n.table-empty-icon {\r\n  width: 48px;\r\n  height: 48px;\r\n  margin: 0 auto var(--spacing-lg);\r\n  opacity: 0.5;\r\n}\r\n\r\n.table-empty-title {\r\n  font-size: var(--text-lg);\r\n  font-weight: var(--fw-semibold);\r\n  margin-bottom: var(--spacing-sm);\r\n  color: var(--slate-900);\r\n}\r\n\r\n.table-empty-description {\r\n  font-size: var(--text-sm);\r\n  color: var(--slate-600);\r\n}\r\n\r\n/* Pagination */\r\n.table-footer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: var(--spacing-lg);\r\n  border-top: 1px solid var(--slate-200);\r\n  background-color: var(--slate-50);\r\n  font-size: var(--text-sm);\r\n}\r\n\r\n.pagination {\r\n  display: flex;\r\n  gap: var(--spacing-xs);\r\n}\r\n\r\n.pagination button {\r\n  width: 32px;\r\n  height: 32px;\r\n  border: 1px solid var(--slate-200);\r\n  background: var(--bg-toolbar, rgba(255,255,255,.05));\r\n  border-radius: var(--radius-sm);\r\n  cursor: pointer;\r\n  transition: all var(--transition-fast);\r\n  font-size: var(--text-sm);\r\n  font-weight: var(--fw-medium);\r\n  color: var(--slate-600);\r\n}\r\n\r\n.pagination button:hover:not(:disabled) {\r\n  border-color: var(--blue-600);\r\n  color: var(--blue-600);\r\n  background-color: var(--blue-50);\r\n}\r\n\r\n.pagination button.active {\r\n  border-color: var(--blue-600);\r\n  background-color: var(--blue-600);\r\n  color: #ffffff;\r\n}\r\n\r\n.pagination button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .list-table {\r\n    font-size: var(--text-xs);\r\n  }\r\n\r\n  .list-table th,\r\n  .list-table td {\r\n    padding: var(--spacing-md) var(--spacing-md);\r\n  }\r\n\r\n  .btn-icon,\r\n  .btn-action {\r\n    width: 28px;\r\n    height: 28px;\r\n  }\r\n\r\n  .btn-icon svg,\r\n  .btn-action svg {\r\n    width: 14px;\r\n    height: 14px;\r\n  }\r\n\r\n  .table-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: var(--spacing-md);\r\n  }\r\n\r\n  .table-filters {\r\n    width: 100%;\r\n  }\r\n\r\n  .table-search {\r\n    width: 100%;\r\n  }\r\n\r\n  .table-header-actions {\r\n    width: 100%;\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .table-footer {\r\n    flex-direction: column;\r\n    gap: var(--spacing-md);\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .table-scroll {\r\n    border-radius: 0;\r\n  }\r\n\r\n  .list-table th,\r\n  .list-table td {\r\n    padding: var(--spacing-sm) var(--spacing-sm);\r\n  }\r\n\r\n  .table-actions {\r\n    gap: 0;\r\n  }\r\n\r\n  .btn-icon,\r\n  .btn-action {\r\n    width: 24px;\r\n    height: 24px;\r\n    border-radius: 2px;\r\n  }\r\n\r\n  .btn-icon svg,\r\n  .btn-action svg {\r\n    width: 12px;\r\n    height: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
